module.exports = __webpack_public_path__ + "static/media/bowen-35.853901dd.jpg";